import { type Middleware } from 'redux';

import { getExperimentValue } from '@canvas/client-feature-flags';
import { manuallyFireExposureEvent } from '@canvas/client-feature-flags/experiments';

const CELL_SELECTION_ACTION_PREFIX = 'cellSelections/';

let experimentHasBeenExposed = false;

/**
 * For our experiment: ctd-5604-databases-selections-performance
 * this disables all cell selections middleware and cleanly turns them off. This will allow us
 * to properly swap the old selections engine with the new engine.
 *
 * @returns
 */
export const cellSelectionsNoOpMiddleware: Middleware = () => (next) => (action) => {
  if (
    typeof action.type === 'string' &&
    action.type.startsWith(CELL_SELECTION_ACTION_PREFIX)
  ) {
    if (
      getExperimentValue('databasesSelectionsPerformance', 'isEnabled', {
        fireExperimentExposure: false,
      })
    ) {
      // Action was called, but we don't forward it to the reducer
      // You can add your own logic here, e.g., emit an event
      return action; // Return the action but don't call next()
    }

    // in services/databases/src/features/selections/create-enrollment-exposure-effect-feature.ts
    // we fire an exposure event for the test cohort, when the exp is on.
    // here, when the experiment is disabled we want to fire an exposure for the control cohort.
    if (!experimentHasBeenExposed) {
      manuallyFireExposureEvent('databasesSelectionsPerformance');

      experimentHasBeenExposed = true;
    }
  }

  return next(action);
};
